import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import SwipeableBottomSheet from 'react-swipeable-bottom-sheet';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { Link } from 'react-router-dom';
import { Popup } from '../../../Global/Popup';
import { base_url } from '../../../Api/Api';
import { Loader } from '../../../Global/Loader';

import Header from '../../../Global/Header';

const CreateTicket = (props) => {

    const [state, setState] = useState({
        data: [],
        categorySubject: [],
        popup: false,
        textApi: 'پیام شما با موفقیت ارسال شد',
        subjectContent: '',
        subjectId: '',
        loader: true,
        loaderApi: false,
        statusBottomSheet: false,
        dropdownClass: false,
        imgUrl: '',
        titleValue: '',
        descriptionValue: '',
        validInput: false
    })

    useEffect(() => {


        base_url.get(`ticket_categories`)
            .then(response => {
                console.log(response.data.ticketcategories)
                setState({
                    ...state,
                    categorySubject: response.data.ticketcategories,
                    loader: false
                })
            })
            .catch(error => {
                if (error.response != undefined) {
                    console.log(error)
                    if (error.response.status == 401) {
                        props.history.push(`/Entrance`)
                    }
                }
            })

    }, []);

    const handleChange = (event) => {
        setState({
            ...state,
            subjectContent: event.target.name,
            subjectId: parseInt(event.target.value),
            statusBottomSheet: false
        })
    };

    const handleInput = (e, target) => {
        setState({
            ...state,
            [target]: e.target.value.trim().length == 0 ? '' : e.target.value
        })
    }

    // toggle bottom sheet
    const closeBottomSheet = (isOpen) => {
        setState({
            ...state,
            statusBottomSheet: !state.statusBottomSheet,
            dropdownClass: state.subjectId.length == 0 ? !state.statusBottomSheet : true
        })
    }

    const loadFile = (event) => {
        var image = document.getElementById('output');
        image.src = URL.createObjectURL(event.target.files[0]);
        setState({
            ...state,
            imgUrl: image.src
        })
    };

    const deletePictuer = () => {
        var image = document.getElementById('output');
        image.src = '';
        setState({
            ...state,
            imgUrl: ''
        })
    }

    const submitTicket = () => {

        if (state.titleValue.length >= 3 &&
            state.descriptionValue.length >= 3 &&
            state.subjectId.length != 0) {

            setState({
                ...state,
                loaderApi: true
            })

            if (state.imgUrl.length == 0) {
                const header = {
                    "Authorization": JSON.parse(localStorage.getItem('api_key')),
                    "content-type": "application/json",
                };
                const dataWithoutImg = {
                    category_id: state.subjectId,
                    title: state.titleValue,
                    message: state.descriptionValue
                };
                console.log(dataWithoutImg)
                base_url.post(`tickets`, dataWithoutImg, {
                    headers: header
                })
                    .then(resp => {
                        console.log(resp)
                        if (resp.data.status == 1) {
                            setState({
                                ...state,
                                popup: true,
                                textApi: 'پیام شما با موفقیت ارسال شد',
                                loaderApi: false
                            })
                        } else {
                            setState({
                                ...state,
                                popup: true,
                                textApi: 'مشکلی بوجود آمده لطفا دوباره سعی کنید',
                                loaderApi: false
                            })
                        }
                    })
                    .catch(error => {
                        if (error.response != undefined) {
                            console.log(error)
                            if (error.response.status == 401) {
                                props.history.push(`/Entrance`)
                            }
                        }
                    })
            } else {

                var data = new FormData(document.getElementById("form"));
                base_url.post(`ticket_image`, data)
                    .then(response => {
                        console.log(response.data)
                        const header = {
                            "Authorization": JSON.parse(localStorage.getItem('api_key')),
                            "content-type": "application/json",
                        };
                        const dataTicket = {
                            category_id: state.subjectId,
                            title: state.titleValue,
                            message: state.descriptionValue,
                            ticketAttach: response.data.ticketAttach
                        };
                        base_url.post(`tickets`, dataTicket, {
                            headers: header
                        })
                            .then(resp => {
                                console.log(resp.data)
                                if (resp.data.status == 1) {
                                    setState({
                                        ...state,
                                        popup: true,
                                        textApi: 'پیام شما با موفقیت ارسال شد',
                                        loaderApi: false
                                    })
                                } else {
                                    setState({
                                        ...state,
                                        popup: true,
                                        textApi: 'مشکلی بوجود آمده لطفا دوباره سعی کنید',
                                        loaderApi: false
                                    })
                                }
                            })
                            .catch(error => {
                                if (error.response != undefined) {
                                    console.log(error)
                                    if (error.response.status == 401) {
                                        props.history.push(`/Entrance`)
                                    }
                                }
                            })
                    })
                    .catch(error => {
                        if (error.response != undefined) {
                            console.log(error)
                            if (error.response.status == 401) {
                                props.history.push(`/Entrance`)
                            }
                        }
                    })
            }

        } else {
            setState({
                ...state,
                validInput: true
            })
        }
    }

    const closePopup = () => {
        setState({
            ...state,
            popup: false
        })
        props.history.goBack()
    }

    return (
        <React.Fragment>
            <Loader
                active={state.loader} />
            <Loader
                active={state.loaderApi} />
            <div className={`instructpg ticket create-ticket ${state.loader ? '' : 'active'}`}>
                <Popup
                    active={state.popup}>
                    <h4>{state.textApi}</h4>
                    <div className="btn-base btn-black btn-sircle">
                        <Button
                            variant="contained"
                            onClick={closePopup} >خروج</Button>
                    </div>
                </Popup>
                <Header
                    innerPage={true}
                    title={`پشتیبانی`} />
                <div className="body-ticket">

                    <div
                        className="input-form"
                        onClick={closeBottomSheet} >
                        <div className={`dropdown-customs ${state.dropdownClass ? 'active' : ''}`}>
                            <span>موضوع</span>
                            <strong>{state.subjectContent}</strong>
                            <i className="icon-arrow-down-sign-to-navigate-fill"></i>
                        </div>
                        <span className={`error-respns ${state.subjectId.length == 0 && state.validInput ? 'active' : ''}`}>
                            <i className="icon-exclamation-mark"></i>
                                موضوع پیام خود را انتخاب کنید
                        </span>
                    </div>
                    <div className="input-form">
                        <TextField
                            id="title"
                            label="عنوان پیام"
                            value={state.titleValue}
                            onChange={(e) => handleInput(e, 'titleValue')}
                        />
                        <span className={`error-respns ${state.titleValue.length <= 3 && state.validInput ? 'active' : ''}`}>
                            <i className="icon-exclamation-mark"></i>
                                عنوان پیام خود کامل وارد کنید
                        </span>
                    </div>
                    <div className="input-form">
                        <TextField
                            id="description"
                            label="متن پیام"
                            multiline
                            rows={3}
                            value={state.descriptionValue}
                            onChange={(e) => handleInput(e, 'descriptionValue')}
                        />
                        <span className={`error-respns ${state.descriptionValue.length <= 3 && state.validInput ? 'active' : ''}`}>
                            <i className="icon-exclamation-mark"></i>
                                متن پیام خود کامل وارد کنید
                        </span>
                    </div>

                    <div className={`pic-upload ${state.imgUrl.length == 0 ? 'slct-img' : ''}`}>
                        <form className="input-select" id="form">
                            <input
                                type="file"
                                accept="image/*"
                                name="ticketAttach"
                                id="file"
                                onChange={(event) => loadFile(event)} />
                            <div className="detail">
                                <i className="icon-upload"></i>
                                <span>آپلود عکس</span>
                            </div>
                        </form>
                        <div className="selected-pic">
                            <img id="output" src="" />
                            <div className="overlay-delete">
                                <i className="icon-bin" onClick={deletePictuer}></i>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="btn-base btn-black btn-sircle">
                    <Button
                        variant="contained"
                        onClick={submitTicket} >ارسال</Button>
                </div>

                <div className="btm-sht">
                    <SwipeableBottomSheet
                        open={state.statusBottomSheet}
                        onChange={(e) => closeBottomSheet(e)}
                        overflowHeight={0}>
                        <div
                            style={{ height: 'auto' }}
                            className="bottom-sheet">
                            {state.categorySubject.length == 0 ? null :
                                <FormControl component="fieldset">
                                    <FormLabel component="legend">موضوع</FormLabel>
                                    <RadioGroup aria-label="subject" name="subject" value={state.subjectId} onChange={handleChange}>
                                        {state.categorySubject.map(item =>
                                            <FormControlLabel
                                                key={item.id}
                                                value={item.id}
                                                name={item.name}
                                                control={<Radio key={item.id} />}
                                                label={item.name} />
                                        )}
                                    </RadioGroup>
                                </FormControl>
                            }
                        </div>
                    </SwipeableBottomSheet>
                </div>

            </div>
        </React.Fragment >
    );
}

export default CreateTicket;